<template>
  <main>
    <section>
      <div class="align-content-center m-4">
        <div class="page_title" style="display: flex;justify-content: center;">
          <div>
            <h3 class="page_title" style="display: inline-block;
                  height: 4.1rem;
                  border-bottom: 3px solid rgb(252, 180, 46); color: rgb(252, 180, 46);">About Us </h3>
          </div>
        </div>
      </div>
      <div style=" height: 30px;background-color: #2C2C2B;text-align: left;; line-height: 30px;">
        <div class="custom-header" style=" display: flex;text-align: center;">

        </div>
      </div>
    </section>
    <section>
      <!-- <div style="width: 100%;margin: 0 auto;" > 
      <hr>
      <div v-for="(item,index) in currentImg" :key="index">
        <img :src="item.url" alt="">
      </div>
     
    </div> -->
      <div style="width: 100%;margin: 0 auto;">
        <table style="width: 100%;background-color: #1D1D1B;margin: 0 auto;min-height: 800px;">
          <tr>
            <td class="col-md-1-1"
              style="vertical-align: top; padding: 0;background-color: transparent;border-right: 1px solid #424242;">
              <section style="background-color: transparent;">
                <table style="width: 100%;">
                  <tr>
                    <td>
                      <div class="tree-box" style="width: 100%;min-width: 200px;">

                        <div class="tree-content" style="margin-top: 5px;overflow: hidden;">
                          <el-tree ref="treeleft" :data="treeData" node-key="id" :indent="0" class="tree-line"
                            :row-style="{'padding-top':'0px','padding-bottom':'0px',height:'30px','line-height':'30px'}"
                            :default-expand-all="true" :highlight-current="false" :expand-on-click-node="false"
                            @node-click="handleNodeClick">
                            <span slot-scope="{ data }" class="custom-tree-node">
                              <template>
                                <div class="node_div">
                                  <span class="name-box">
                                    {{ data.name }}
                                  </span>
                                </div>
                              </template>
                            </span>
                          </el-tree>
                        </div>
                      </div>
                    </td>
                  </tr>
                </table>
              </section>
            </td>
            <td class="container col-md-10-1" style="vertical-align: top;padding-top: 30px;text-align: center;">
              <div v-for="(item,index) in currentImg" :key="index">
                <img :src="item.url" alt="" style="padding-top: 30px;max-width: none; 
                    width: auto;    
                    height: auto;   " loading="lazy" >
              </div>
              <div style="height: 80px;"></div>
            </td>
          </tr>
        </table>
      </div>
    </section>

  </main>
</template>

<script>

  import { getDataInfo } from "@/api/rbac/about";
  export default {
    data() {
      return {

        treeData: [],
        currentImg: [],
      };
    },
    computed: {
      // displayedCertificate() {
      //   const start = this.certificateCurrentPage;
      //   const end = start + this.certificateItemsPerPage;
      //   return this.certificate.slice(start, end);
      // },

      // displayedCourse() {
      //   const start = this.courseCurrentPage;
      //   const end = start + this.courseItemsPerPage;
      //   return this.course.slice(start, end);
      // }

    },
    methods: {
      navigateTo() {
        this.$router.push(`${this.$route.path}/name`);
      },
      next() {
        // 切换到下一张
        if (this.courseCurrentPage < this.course.length - this.courseItemsPerPage) {
          this.courseCurrentPage += 1
        }
      },
      prev() {
        // 切换到上一张
        if (this.courseCurrentPage > 0) {
          this.courseCurrentPage -= 1
        }
      },
      goToSlide(index) {
        // 跳转到指定图片
        this.certificateCurrentPage = index;
      },
      getStyle(index) {
        // 动态设置每张图片的位置
        const total = this.certificate.length;
        const offset = index - this.certificateCurrentPage;

        // 确保循环索引始终正确（-1 = 最后一张，+1 = 下一张）
        const position = offset < 0 ? offset + total : offset % total;

        // 根据位置设置对应的样式
        if (position === 0) {
          return { transform: "translateX(0) scale(1.2)", zIndex: 3, transition: "all opacity 5s linear" };
        } else if (position === 1) {
          return { transform: "translateX(30.5rem) scale(0.8)", zIndex: 1, transition: "all opacity 5s ease-in-out" };
        } else if (position === 2) {
          return { transform: "translateX(16.75rem) scale(0.95)", zIndex: 2, transition: "all opacity 5s ease-in-out" };
        } else if (position === total - 1) {
          return { transform: "translateX(-30.5rem) scale(0.8)", zIndex: 1, transition: "all opacity 5s ease-in-out" };
        } else if (position === total - 2) {
          return { transform: "translateX(-16.75rem) scale(0.95)", zIndex: 2, transition: "all opacity 5s ease-in-out" };
        } else {
          return { display: "none" }; // 其他图片隐藏
        }
      },
      //获取数据
      async getTypeList() {
        this.treeData = [];
        this.currentImg = [];
        getDataInfo({ strType: 'aboutUs' }).then(res => {
          if (res.data.length == 0) {
            // console.log(this.treeData)
          }
          else {
            let firstNode = {
              id: 0,
              name: 'Sanmak',
              url: '',
              children: []
            }
            res.data.forEach(element => {
              let secNode = { id: element.id, name: element.name, url: element.url, children: [] }
              firstNode.children.push(secNode);
              // this.currentImg.push({url:'../../../assets/img/About/'+element.url})
            });
            this.treeData.push(firstNode);
          }

          if (this.treeData.length > 0) {
            if (this.$route.params.id != undefined) {
              var node = this.treeData[0].children.filter(item => item.id == this.$route.params.id)
              this.$nextTick(() => {
                this.$refs.treeleft.setCurrentKey(node[0].id);
              });

              this.currentImg.push({ url: '../../../assets/img/About/' + node[0].url })
            }
            else {
              this.$nextTick(() => {
                this.$refs.treeleft.setCurrentKey(this.treeData[0].children[0].id);
              });

              this.currentImg.push({ url: '../../../assets/img/About/' + this.treeData[0].children[0].url })
            }
          }
        })
      },
      handleNodeClick(data, node, tree) {
        console.log('Node clicked:', data, node, tree);

        // 在这里处理节点点击的逻辑
        this.currentImg = [];
        if (node.data.url.length == 0) {
          data.children.forEach(element => {
            if (element.url.length > 0) {
              this.currentImg.push({ url: '../../../assets/img/About/' + element.url })
            }
          });
        }
        else {
          this.currentImg.push({ url: '../../../assets/img/About/' + node.data.url })
        }
      },
    },
    mounted() {
      this.getTypeList();
    },
  };
</script>

<style scoped>
  @import '../../assets/css/main.css';

  .tree-line {
    background-color: transparent;
    color: #D3D3D2;
  }

  ::v-deep .el-tree-node.is-current>.el-tree-node__content {
    background: #FCB42E !important;
    color: black;
  }

  /* ::v-deep .el-tree-node > .el-tree-node__content .name-box:first-child  {
  color: rebeccapurple !important;
} */
  /* ::v-deep .el-tree > .el-tree-node > .el-tree-node__content {
  pointer-events: none;
} */
  /* ::v-deep .el-tree-node:first-of-type  {
  color: red;
} */

  :deep(.carousel) {
    position: relative;
    width: 100%;
    height: 35rem;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  :deep(.carousel-wrapper) {
    position: relative;
    width: 17rem;
    height: 35rem;
    display: flex;
    align-items: center;
    justify-content: center;
    perspective: 1000px;
  }

  :deep(.carousel-item) {
    position: absolute;
    width: 17rem;
    height: 32rem;
    transition: transform 0.5s ease, z-index 0.5s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  :deep(.carousel-item img) {
    width: 100%;
    height: auto;
  }

  :deep(.custom-svg-img) {
    filter: brightness(0) saturate(100%) invert(26%) sepia(0%) saturate(138%) hue-rotate(273deg) brightness(93%) contrast(96%)
  }

  :deep(img) {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  :deep(.introduction_img) {
    max-height: 24rem;
  }

  :deep(.introduction_text) {
    position: relative;
    display: flex;
    max-height: 24rem;
    overflow-x: hidden;
  }

  :deep(.introduction_text::-webkit-scrollbar) {
    width: 0.2rem;
  }

  :deep(.introduction_text::-webkit-scrollbar-thumb) {
    background-color: #FCB42E;
    border-radius: 4px;
  }

  :deep(.introduction_text::-webkit-scrollbar-thumb:hover) {
    background-color: #FCB42E;
  }

  :deep(.introduction_text::-webkit-scrollbar-track) {
    background-color: #606060;
    border-radius: 4px;
  }

  :deep(hr) {
    color: #3E3E3D;
    background-color: #3E3E3D;
    height: 1px;
  }

  :deep(.photo-group) {
    display: flex;
    justify-content: left;
    flex-wrap: wrap;
  }

  :deep(.photo-container) {
    text-align: left;
    position: relative;
    width: 14.7rem;
    line-height: 2.2rem;
    cursor: pointer;
  }

  :deep(.photo-container h3) {
    color: #FCB42E;
  }

  :deep(.photo-container span) {
    font-size: 16px;
    font-weight: lighter;
  }

  :deep(.course-group) {
    display: flex;
    justify-content: left;
    flex-wrap: wrap;
  }

  :deep(.course-container) {
    place-items: center;
    text-align: left;
    position: relative;
    width: 14.7rem;
    line-height: 2.2rem;
    cursor: pointer;
  }

  :deep(.course-container .dot) {
    height: 1rem;
    width: 1rem;
    border-radius: 50%;
    background-color: #fff;
    top: 2.4rem;
    left: 45%;
    position: absolute;
  }

  :deep(.course-container .course-content) {
    background-color: #454545;
    width: 10.5rem;
    height: 13.75rem;
    border-radius: 4px;
    place-items: center
  }

  :deep(.course-content>div) {
    background-color: #FCB42E;
    border-radius: 50%;
    width: 3rem;
    height: 3rem;
    text-align: center;
    margin: 0 auto;
  }

  :deep(.course-content>div img) {
    padding: 10px;
    filter: brightness(0) saturate(100%) invert(26%) sepia(0%) saturate(138%) hue-rotate(273deg) brightness(93%) contrast(96%)
  }

  :deep(.course-content>p) {
    overflow: hidden;
    font-size: 15px;
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
  }

  :deep(.course-container .course-content p) {
    font-size: 14px;
    line-height: 1.2rem;
  }

  :deep(.course-container:hover h4) {
    color: #FCB42E;
    transition: color 0.5s ease;
  }

  .course-container:hover .dot,
  .course-container:hover .course-content {
    background-color: #FCB42E;
    transition: background-color 0.5s ease;
  }

  :deep(.course-container:hover .course-content>div) {
    background-color: #fff;
    transition: background-color 0.5s ease;
  }

  :deep(.course-container:hover .course-content>div img) {
    filter: brightness(0) saturate(100%) invert(87%) sepia(41%) saturate(3489%) hue-rotate(335deg) brightness(104%) contrast(98%);
  }

  :deep(.control) {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    font-size: 24px;
    background: rgba(0, 0, 0, 0.5);
    color: white;
    border: none;
    cursor: pointer;
    z-index: 20;
  }

  :deep(.control.left) {
    left: 10%;
  }

  :deep(.control.right) {
    right: 10%;
  }

  :deep(.control:hover) {
    background: rgba(0, 0, 0, 0.8);
  }

  :deep(.certificate) {
    display: flex;
    align-items: center;
    padding: 1.2rem 0;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
  }
</style>